import type { ReactNode } from "react";

type PanelProps = {
  title?: string;
  eyebrow?: string;
  aside?: ReactNode;
  children: ReactNode;
  className?: string;
};

export function Panel({ title, eyebrow, aside, children, className = "" }: PanelProps) {
  return (
    <section className={`panel ${className}`}>
      {(title || eyebrow || aside) && (
        <header className="panel__header">
          <div>
            {eyebrow && <p className="eyebrow">{eyebrow}</p>}
            {title && <h2>{title}</h2>}
          </div>
          {aside && <div className="panel__aside">{aside}</div>}
        </header>
      )}
      {children}
    </section>
  );
}
